













































import { Vue, Component } from 'vue-property-decorator';
import { IFavoriteModalProps } from '@/components/Globals/types/custom.t';
import CustomContainer from '@/components/Globals/CustomContainer.vue';
import CustomModal from '@/components/Modals/wrapper/modalWrapper.vue';
import CustomImage from '@/components/Globals/CustomImage.vue';
import ModalHeader from '@/components/molecule.modal.header.vue';
import CustomText from '@/components/Globals/CustomText.vue';
import baseSpinner from '@/components/Spinner';

import favorites from '@/mixins/Favorites';

@Component({
  components: {
    CustomContainer,
    CustomModal,
    ModalHeader,
    CustomText,
    CustomImage,
    baseSpinner
  },
  mixins: [favorites],
})
export default class Favorite extends Vue {
  [x: string]: any;

  contentProps: IFavoriteModalProps | null = null;

  get textMessage() {
    return this.contentProps?.favoriteSaved ? this.translations.favoritesSuccessMessage : this.translations.favoritesErrorMessage;
  }

  beforeOpenModal(event: any): void {
    this.contentProps = event.params || null;
    this.getProductImage({ recipe_id: this.$store.state.recipe.recipeId });
  }

  closeAction(): void {
    this.contentProps = null;
    this.imageUrl = '';
    this.showSpinner = true;

    this.$modal.hide('favoriteModal');
  }
}
